import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import URLConstants from '../../constants/urlConstants';
import { SentCampaignType } from '../../@types/sentCampaignType';


type SendMessageState = {
    isLoader: boolean;
    error: boolean;
    sendCampaign: SentCampaignType;
}

const initialState: SendMessageState = {
    isLoader: false,
    error: false,
    sendCampaign: { } as SentCampaignType
}

const slice = createSlice({
    name: 'sendCampaign',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoader = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoader = false;
            state.error = action.payload;
        },

        // SEND CAMPAIGN
        sendCampaignSuccess(state, action) {
            state.isLoader = false;
            state.sendCampaign = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function sendNewCampaign(values:any, header:any, body:any) {
    if (Object.keys(header).length === 0) {
        header = null;
    }
    if (Object.keys(body).length === 0) {
        body = null;
    }

 let messages=   []
        values.toContacts.map(contacts =>
            messages.push(  { 
                "to": contacts,         
                "templateName": values.templateName,              
                "language": values.language,
                "header" :header,
                "body":body,
                "button": null
            } )   
        )

    return async () => {
        dispatch(slice.actions.startLoading(true));
        try {
            const response = await axios.post(URLConstants.SEND_CAMPAIGN_BASE_URL, {"campaignName":values.campaignName,"scheduleTime" : values.scheduleTime, "messages" : messages}
            );
            dispatch(slice.actions.sendCampaignSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}

export function sendCampaignUsingJSONFIle(values:any, campaignId: string) {
    return async () => {
        dispatch(slice.actions.startLoading(true));
        try {
            const response = await axios.post(URLConstants.SEND_CAMPAIGN_USING_JSON_BASE_URL, {"campaignName":values.campaignName,"scheduleTime" : values.scheduleTime, "campaignId" : campaignId}
            );
            dispatch(slice.actions.sendCampaignSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}

export function sendCampaignV4UsingJSONFIle(values:any, campaignId: string,campaignMessageCount: number) {
    return async () => {
        dispatch(slice.actions.startLoading(true));
        try {
            const response = await axios.post(URLConstants.SEND_CAMPAIGN_V4_USING_JSON_BASE_URL, {"campaignName":values.campaignName,"scheduleTime" : values.scheduleTime, "campaignId" : campaignId, "campaignMessageCount" : campaignMessageCount}
            );
            dispatch(slice.actions.sendCampaignSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}
export function sendDynamicCampaign(campaignName : any ,scheduleTime :any,messages:any, ) {
    return async () => {
        // dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(URLConstants.SEND_CAMPAIGN_BASE_URL, {campaignName,scheduleTime,messages}
            );
            dispatch(slice.actions.sendCampaignSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}

export function sendDynamicCampaignUsingJSONFile(campaignName : any ,scheduleTime :any,campaignId:string, ) {
    return async () => {
        // dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(URLConstants.SEND_CAMPAIGN_USING_JSON_BASE_URL, {campaignName,scheduleTime,campaignId}
            );
            dispatch(slice.actions.sendCampaignSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}

export function sendDynamicCampaignV4UsingJSONFile(campaignName : any ,scheduleTime :any,campaignId:string,campaignMessageCount: number ) {
    return async () => {
        // dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(URLConstants.SEND_CAMPAIGN_V4_USING_JSON_BASE_URL, {campaignName,scheduleTime,campaignId,campaignMessageCount}
            );
            dispatch(slice.actions.sendCampaignSuccess(response.data.data));
        } catch (error:any) {
            dispatch(slice.actions.hasError(error));
            return {message : error?.message, hasError : true} 
        }
    };

}